'use strict';
import Cookies from 'js-cookie';
import L from "leaflet";



jQuery(function () {
    const lat = $('#contact-map').attr('data-lat');
    const lon = $('#contact-map').attr('data-lon');
    //cookie set and unset in handlers

    //MAPBOX//
    var myIcon = L.icon({
        iconUrl: './assets/template/dist/images/map_icon.png',
        iconSize: [60, 90],
        iconAnchor: [30, 100],
        popupAnchor: [-3, -76],
    });

    let map = null;

    const showMap = () => {
        if (lat && lon && Cookies.get('mc') === 'true') {
            $('.map-placeholder').remove();
            map = L.map('contact-map', {attributionControl: false,}).setView([lat, lon], 13);
            L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}', {
                attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
                maxZoom: 18,
                id: 'mapbox/streets-v11',
                tileSize: 512,
                zoomOffset: -1,
                accessToken: 'pk.eyJ1IjoiZG9wZWxlc3MiLCJhIjoiY2tmcW15ZXBpMHgwbTJxbGhlaTBiZGVldCJ9.S3AlAb5cwys6JYD8FWIyqA'
            }).addTo(map);
            L.marker([lat, lon], {
                icon: myIcon
            }).addTo(map);
        }
    };

    showMap();

    $('.allowMap').on('click', function (e) {
        e.preventDefault();
        setTimeout(function () {
            if (Cookies.get('mc') === 'true' && map === null) {
                showMap();
            }
        }, 300);
    });

});

const contactForm = document.getElementById("contact-form");

let renderErrors = (errors) => {
    for (let [field, error] of Object.entries(errors)) {
        const element = $('#contact-form').find('#' + field).closest('.form-element');
        element.addClass('error');
        element.find('.error-text').html(error);
    }
    $('#submit').addClass('inactive');
}

let clearError = (element) => {
    let parent = element.closest('.form-element');
    parent.removeClass('error');
    parent.find('.error-text').html('&nbsp;');
    if ($('.form-element.error').length == 0) {
        $('#submit').removeClass('inactive');
    }
}

let showPreloader = () => {
    $('#form-busy').fadeIn();
}
let hidePreloader = () => {
    $('#form-busy').fadeOut();
}

let showSuccessMessage = () => {
    $('#message-sent').addClass('isvis');
    setTimeout(function () {
        $('#message-sent').removeClass('isvis');
    }, 5000);
}

let resetForm = () => {
    contactForm.reset();
    $('#contact-form').find('.form-element').removeClass('active').find('.checkbox-vis').removeClass('selected');
}

let sendRequerst = (data) => {
    showPreloader();
    fetch('assets/template/dist/php/contact.php', {
        method: 'post',
        body: data
    }).then(response => {
        return response.text();
    }).then(responseString => {
        hidePreloader();
        const output = JSON.parse(responseString);
        if (output.error == 1) {
            renderErrors(output.errors);
        } else {
            if (output.mailSent == 1) {
                resetForm();
                showSuccessMessage();
            } else {
                alert('Etwas stimmt nicht. Das ist nicht Ihr Schuld :(');
            }
        }
    }).catch(error => {
        alert('Etwas stimmt nicht. Das ist nicht Ihr Schuld :(');
        console.log(error)
    })
}


if(contactForm){
    contactForm.addEventListener('submit', e => {
        e.preventDefault();
        const formData = new FormData(contactForm);
        if (!$('#submit').hasClass('inactive')) {
            sendRequerst(formData);
        }
    })
}

jQuery(function () {
    $('#contact-form').find('input,textarea').each(function () {
        $(this).on('focus', function () {
            $(this).closest('.form-element').addClass('active');
            clearError($(this));
        })
        $(this).on('blur', function () {
            if (!$(this).val()) {
                $(this).closest('.form-element').removeClass('active');
            }
        })
    })
    $('#contact-form').find('.form-element.checkbox').each(function () {
        $(this).find('input').on('focus', function () {
            $(this).closest('.form-element').find('.checkbox-vis').addClass('focus');
        })
        $(this).find('input').on('blur', function () {
            $(this).closest('.form-element').find('.checkbox-vis').removeClass('focus');
        })

        $(this).find('input').change(function () {
            if (this.checked) {
                $(this).closest('.form-element').find('.checkbox-vis').addClass('selected');
            } else {
                $(this).closest('.form-element').find('.checkbox-vis').removeClass('selected');
            }
        });
    })
    $('#contact-form').find('.form-element.checkbox').find('label').on('click', function (e) {
        if ($(e.target).is('small')) {
            //console.log(e.target)
        }
    })

})
